<template>
    <div class="p-col-12">
        <page-header title="dataTable.user.title" :actions="pageActions"/>
        <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
    </div>
</template>

<script>
    import UserBusiness from "@/business/UserBusiness";
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
    import FrontBusiness from "@/business/FrontBusiness";
    import PageHeader from "@/components/page/PageHeader";
    import DialogService from "@/business/ModalBusiness";
    import Audit from "@/viewer/user/Audit";
    import { _getTypeUserLabel } from "@/constants/TypeUser.js";

    export default {
        name: "UserList",
        components: {PageHeader, AncestrylineDataTable},

        data() {
            return {
                dataFunction: UserBusiness.pagination,
                columns: [
                    {field: "avatar", header: 'dataTable.user.columns.name', sortable:true, type: 'image', imageLabel: 'name'},
                    {field: "userName", header: 'dataTable.user.columns.userName', sortable:true},
                    {field: "typeUser", header: 'dataTable.user.columns.typeUser', sortable:true, type: 'function', function: _getTypeUserLabel },
                    {field: "active", header: 'dataTable.user.columns.active', sortable:true, type: 'boolean'},
                    {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
                        actions: [
                            {icon: 'pi pi-user-edit', title: 'dataTable.user.columns.edit', function: this.editUser},
                        ]
                    },
                ],
                pageActions: [
                    {icon: 'pi pi-user-plus', label: 'dataTable.user.add', url: '/user'},
                    {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
                ],
            }
        },

        methods: {

            editUser(user){
                FrontBusiness.redirect(`/user/${user.id}`);
            },

            openModal(){
                DialogService.openModal(Audit, {business: UserBusiness});
            }

        }

    }
</script>

<style scoped>

</style>
